import React, { useState } from "react";
import { MdClose, MdKeyboardArrowDown } from "../utils/Icons";
import { useOrderProcessingContext } from "../context/OrderProcessingContext";

const promoCodes = [
  {
    promoCode: "FINELABS10",
    title: "Flat 10% off on Dr Lal PathLabs tests",
    description:
      "Minimum order value should be ₹ 799. Maximum discount can be availed ₹ 1500. Flat 10% off on Dr Lal PathLabs routine tests only.",
  },
  {
    promoCode: "FINELABS20",
    title: "Flat 20% off on your first 3 orders",
    description:
      "Minimum order value should be ₹ 799. Maximum discount can be availed ₹ 1500. Flat 20% off on routine tests, 15% on radiology, 12% on packages, 10% on special panel/ specialized Tests. User can avail this offer max. 3 times.",
  },
  {
    promoCode: "FREEHOME",
    title: "Free home collection on most lab tests only",
    description:
      "Avail this for free home collection on most lab tests only",
  },
  {
    promoCode:"EXTRADISC200",
    title:"Extra 200 ₹ discount on your order",
    description:
      "Minimum order value should be ₹ 799. Maximum discount can be availed ₹ 1500. Extra 200 ₹ discount on your order.",
  },
  {
    promoCode:"FREETEST",
    title:"Free 1 test on your order",
    description:
      "For this offer to be availed, minimum order value should be grater than ₹ 499.",
  }
];

const PromoCodePopup = () => {
  const {
    setIsPromoCode,
    promoCode,
    setPromoCode,
    handleApplyPromoCode,
    promoCodeMessage,
    setPromoCodeMessage
  } = useOrderProcessingContext();
  const [isViewMore, setIsViewMore] = useState();

  const handlePromoCodeChange = (e) => {
    const capitalizedPromoCode = e.target.value.toUpperCase();
    setPromoCode(capitalizedPromoCode);
  };

  const handlePromoCodeApplyClick = (promoCodeToAdd) => {
    setPromoCode(promoCodeToAdd);
  };

  const handleViewMore = (index) => {
    setIsViewMore(index);
  };

  return (
    <div className="w-screen h-screen bg-black/25 backdrop-blur flex justify-center items-center p-[3%] fixed left-0 top-0 right-0 bottom-0 z-50">
      <div className="w-full lg:w-[30%] h-full lg:h-[75%] bg-whiteColor flex flex-col justify-between items-center rounded-xl lg:rounded-3xl p-[2%] lg:p-[1%]">
        <div className="w-full h-fit flex flex-col justify-center items-center px-[3%]">
          <div className="w-full h-fit flex justify-end items-center">
            <button
              className="text-[5vw] lg:text-[1.25vw] text-textPrimaryColor"
              onClick={() => {setIsPromoCode(false); setPromoCodeMessage({ flag: null, message: ""}) }}
            >
              <MdClose />
            </button>
          </div>
          <span className="font-semibold text-[5vw] lg:text-[1.25vw] text-textPrimaryColor mb-[5%]">
            Offers & Discounts
          </span>
          <div className="w-full h-fit flex justify-between items-center">
            <input
              type="text"
              value={promoCode}
              placeholder="Enter promo code"
              onChange={handlePromoCodeChange}
              className="w-2/3 h-11 lg:h-fit bg-secondaryColor flex justify-between items-center border border-accentColor rounded-xl px-[3%] py-[2.25%] font-normal text-[3.5vw] lg:text-[0.8vw] text-textPrimaryColor outline-none"
            />
            <button className="btn-primary" onClick={handleApplyPromoCode}>
              Apply
            </button>
          </div>
          {promoCodeMessage?.message?.length > 0 && !promoCodeMessage?.flag && (
            <div className="w-full h-fit mt-2">
              <p
                className={`font-normal text-[3.5vw] lg:text-[0.9vw] ${
                  promoCodeMessage?.flag ? "text-green-500" : "text-red-500"
                }`}
              >
                {promoCodeMessage?.message}
              </p>
            </div>
          )}
        </div>
        <div className="w-full h-[80%] lg:h-[67.5%] flex flex-col justify-start items-center px-[3%] space-y-[2%] mb-[2%] overflow-x-hidden overflow-y-scroll scrollbar-custom">
          {promoCodes?.map((item, index) => (
            <div className="w-full h-fit  relative" key={index}>
              <img
                src={
                  isViewMore === index
                    ? "/assets/promocode-cutout-lg.svg"
                    : "/assets/promocode-cutout-sm.svg"
                }
                alt="promocode-cutout-sm"
                className="w-full"
              />
              <div className="w-full h-fit px-[7.5%] py-[3%] absolute left-0 top-0 right-0 z-10">
                <div className="w-full h-fit space-y-[2%]">
                  <div className="w-full h-fit flex justify-between items-center">
                    <div className="w-[75%] h-fit flex justify-start items-center space-x-2">
                      <img
                        src="/assets/percent-icon.svg"
                        alt="percent-icon.svg"
                      />
                      <span className="font-semibold text-[3.5vw] lg:text-[0.8vw] text-textPrimaryColor">
                        {item.promoCode}
                      </span>
                    </div>
                    <button
                      className="font-normal text-[3.5vw] lg:text-[0.8vw] text-primaryColor"
                      onClick={() => handlePromoCodeApplyClick(item.promoCode)}
                    >
                      Copy
                    </button>
                  </div>
                  <p className="font-normal text-[3.5vw] lg:text-[0.8vw] text-textSecondaryColor ml-8">
                    {item.title}
                  </p>
                </div>
                <img
                  src="/assets/dotted-line.svg"
                  alt="dotted-line"
                  className="my-[3%]"
                />
                {isViewMore === index ? (
                  <p className="font-normal text-[12px] lg:text-[0.8vw] text-textSecondaryColor ml-2 ">
                    {item.description}
                  </p>
                ) : (
                  <p className="font-normal text-[12px] lg:text-[0.8vw] text-textSecondaryColor ml-2">
                    {item.description?.slice(0, 60)}...
                  </p>
                )}
                <div className="w-full h-fit flex justify-end items-center mt-[1%]">
                  <button
                    className="flex items-center space-x-1 font-normal text-[12px] lg:text-[0.8vw] text-[#57636C]"
                    onClick={()=>index===isViewMore?handleViewMore():handleViewMore(index)}
                  >
                    <span>{isViewMore===index ? "view less" : "view more"}</span>
                    <MdKeyboardArrowDown
                      className={`text-lg ${
                        isViewMore===index && "rotate-180 duration-300"
                      }`}
                    />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PromoCodePopup;
